import React from "react";
import { connect } from "react-redux";
import { useMountEffect } from "../../../hooks/LifeCycle";
import useEmpresa from "../../../hooks/useEmpresa";
import IngresoActions from "../../../stores/ingreso/Actions";
import { useHistory } from "react-router-dom";
import CustomLayout from "../../../components/CustomLayout/CustomLayout";
import CustomButton from "../../../components/CustomButton/CustomButton";
import CustomSeparator from "../../../components/Common/CustomSeparator";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import AfiliadoIngresoForm from "../components/AfiliadoIngresoForm";
import AutorizacionIngresoForm from "../components/AutorizacionIngresoForm";
import ProcedimientosIngresoTabla from "../components/ProcedimientosIngresoTabla";
import BusquedaIngresoForm from "../components/BusquedaIngresoForm";
import ProcedimientosPermitidosTabla from "../components/ProcedimientosPermitidosTabla";
import CustomModal from "../../../components/CustomModal/CustomModal";
import TittleLine from "../../../components/Common/TittleLine";
import {
  IngresoFormButtonsContainer,
  IngresoFormButtonsRight,
  IngresoFormButtonsLeft,
} from "../styles/IngresoStyles";
import { EMPRESA } from "../../../utils/Constant";
import CustomAlert from "../../../components/Common/CustomAlert";
import CheckRender from "../../../components/Common/CheckRender";
import ModalLoader from "../../../components/Common/ModalLoader";
import Colors from "../../../themes/Colors";
import {
  obtenerFrecuenciaValida,
  camposRequeridosCompletos,
} from "../utils/IngresoUtils";
import { isEmptyValue } from "../../../utils/StringUtil";
import { ALERTAS_GENERICAS } from "../../../utils/AlertasGenericas";

const CierreCuentasScreen = (props) => {
  const {
    formCierreCuentasData,
    consultarIngresoLoading,
    getProcedimientosPermitidosCierreCuentasLoading,
    validarProcedimientoCierreCuentasLoading,
    eliminarProcedimientoCierreCuentasLoading,
    cerrarCuentaClinicaLoading,
    authUserData,
  } = props;
  const history = useHistory();
  const empresa = useEmpresa();
  const { prestador } = authUserData;
  const isPrimera = empresa?.CODIGO === EMPRESA.PRIMERA.CODIGO;

  useMountEffect(() => {
    if (!isPrimera || !authUserData?.prestador?.permiteCierreCuenta) {
      history.push("/dashboard");
      return;
    }
  });

  const showModalLoader = () => {
    return (
      consultarIngresoLoading ||
      getProcedimientosPermitidosCierreCuentasLoading ||
      validarProcedimientoCierreCuentasLoading ||
      eliminarProcedimientoCierreCuentasLoading ||
      cerrarCuentaClinicaLoading
    );
  };

  const onCloseModalProcedimientosPermitidos = () => {
    props.formCierreCuentas({
      ...formCierreCuentasData,
      showModalProcedimientosPermitidos: false,
    });
  };

  const onCancel = () => {
    props.formCierreCuentas({
      ...formCierreCuentasData,
      alertConfig: {
        type: "confirm",
        title: "¿Estás seguro?",
        message: `Recuerda que si limpias los datos tendrás que iniciar desde cero.`,
        onConfirm: () => {
          props.formCierreCuentas({
            ...formCierreCuentasData,
            showDetalleIngreso: false,
          });
        },
        onCancel: () => {
          props.formCierreCuentas({
            ...formCierreCuentasData,
            showAlert: false,
          });
        },
      },
      showAlert: true,
    });
  };

  const goToDetalleCierreCuenta = () => {
    history.push({
      pathname: "/detalle-cierre-cuenta",
      state: {
        numeroIngreso: formCierreCuentasData?.numeroIngreso,
        anioIngreso: formCierreCuentasData?.anio,
      },
    });
  };

  const agregarProcedimientoManual = () => {
    const {
      codigoCobertura,
      fechaServicio,
      fechaSalida,
      frecuenciaCobertura,
      codigoPss,
      tipoPss,
    } = formCierreCuentasData;

    if (isEmptyValue(codigoCobertura) || Number(codigoCobertura) === 0) {
      props.formCierreCuentas({
        ...formCierreCuentasData,
        alertConfig: {
          type: "info",
          title: "¡Hola!",
          message: ALERTAS_GENERICAS.CODIGO_COBERTURA_REQUERIDO,
          onConfirm: () => {
            props.formCierreCuentas({
              ...formCierreCuentasData,
              showAlert: false,
              showRequired: true,
            });
          },
        },
        showAlert: true,
        showRequired: true,
      });
      return;
    }

    if (!camposRequeridosCompletos(formCierreCuentasData)) {
      props.formCierreCuentas({
        ...formCierreCuentasData,
        alertConfig: {
          type: "info",
          title: "¡Hola!",
          message: ALERTAS_GENERICAS.CAMPOS_REQUERIDOS,
          onConfirm: () => {
            props.formCierreCuentas({
              ...formCierreCuentasData,
              showAlert: false,
              showRequired: true,
            });
          },
        },
        showAlert: true,
        showRequired: true,
      });
      return;
    }

    if (
      isEmptyValue(tipoPss) ||
      isEmptyValue(codigoPss) ||
      Number(codigoPss) === 0
    ) {
      props.validarProcedimientoCierreCuentas({
        formCierreCuentasData: {
          ...formCierreCuentasData,
          tipoPss: prestador?.tipoPss,
          codigoPss: prestador?.codigo,
        },
        formHandler: props.formCierreCuentas,
        codigoProcedimiento: codigoCobertura,
        frecuencia: obtenerFrecuenciaValida(
          frecuenciaCobertura,
          codigoCobertura,
          fechaServicio,
          fechaSalida
        ),
      });
      return;
    }

    props.validarProcedimientoCierreCuentas({
      formCierreCuentasData,
      formHandler: props.formCierreCuentas,
      codigoProcedimiento: codigoCobertura,
      frecuencia: obtenerFrecuenciaValida(
        frecuenciaCobertura,
        codigoCobertura,
        fechaServicio,
        fechaSalida
      ),
    });
  };

  const cerrarCuentaClinica = () => {
    if (!camposRequeridosCompletos(formCierreCuentasData)) {
      props.formCierreCuentas({
        ...formCierreCuentasData,
        alertConfig: {
          type: "info",
          title: "¡Hola!",
          message: ALERTAS_GENERICAS.CAMPOS_REQUERIDOS,
          onConfirm: () => {
            props.formCierreCuentas({
              ...formCierreCuentasData,
              showAlert: false,
              showRequired: true,
            });
          },
        },
        showAlert: true,
        showRequired: true,
      });
      return;
    }

    props.formCierreCuentas({
      ...formCierreCuentasData,
      alertConfig: {
        type: "confirm",
        title: "¿Está seguro?",
        message: `¿Está seguro que desea culminar con el proceso de cierre de la cuenta clínica?`,
        onConfirm: () => {
          props.formCierreCuentas({
            ...formCierreCuentasData,
            showAlert: false,
          });

          props.cerrarCuentaClinica({
            formCierreCuentasData,
            tipoReclamante: prestador?.tipoPss,
            codigoReclamante: prestador?.codigo,
            formHandler: props.formCierreCuentas,
            callBack: goToDetalleCierreCuenta,
          });
        },
        onCancel: () => {
          props.formCierreCuentas({
            ...formCierreCuentasData,
            showAlert: false,
          });
        },
      },
      showAlert: true,
    });
  };

  return (
    <CustomLayout
      showMenuNav={true}
      footerPosition={
        formCierreCuentasData?.showDetalleIngreso ? "relative" : "fixed"
      }
      footerWidth={formCierreCuentasData?.showDetalleIngreso ? "auto" : "100%"}
    >
      <Section>
        <TittleLine title={"Cierre de cuentas clínicas"} weight={"bold"} />
      </Section>

      <CheckRender allowed={!formCierreCuentasData?.showDetalleIngreso}>
        <Section padding={"5px"}>
          <BusquedaIngresoForm />
        </Section>
      </CheckRender>

      <CheckRender allowed={formCierreCuentasData?.showDetalleIngreso}>
        <Section>
          <AfiliadoIngresoForm />
        </Section>

        <Section padding={"5px"}>
          <AutorizacionIngresoForm />
        </Section>

        <Section align="center" flexDirection={"column"} padding={"10px"}>
          <ProcedimientosIngresoTabla />
        </Section>

        <Section>
          <TittleLine />
        </Section>

        <Section align={"center"} padding={"10px"}>
          <IngresoFormButtonsContainer>
            <IngresoFormButtonsLeft>
              <CustomButton
                label={"Agregar Procedimiento"}
                onClick={agregarProcedimientoManual}
                disabled={showModalLoader()}
                weight={"bold"}
                hoverColor={empresa?.COLOR_PRINCIPAL}
                bgColor={Colors.white}
                textColor={empresa?.COLOR_PRINCIPAL}
                border={`1px solid ${empresa?.COLOR_PRINCIPAL}`}
              />
            </IngresoFormButtonsLeft>

            <IngresoFormButtonsRight>
              <CustomButton
                label={"Cierre de cuenta"}
                onClick={cerrarCuentaClinica}
                bgColor={empresa?.COLOR_SECUNDARIO}
                hoverColor={empresa?.COLOR_PRINCIPAL}
                weight={"bold"}
                disabled={showModalLoader()}
              />
              <CustomSeparator width={"10px"} />
              <CustomButton
                label={"Cancelar"}
                onClick={onCancel}
                disabled={false}
                weight={"bold"}
                hoverColor={Colors.huMyHealth}
                bgColor={Colors.white}
                textColor={Colors.huMyHealth}
                border={`1px solid ${Colors.huMyHealth}`}
              />
            </IngresoFormButtonsRight>
          </IngresoFormButtonsContainer>
        </Section>
      </CheckRender>

      <CustomModal
        isOpen={formCierreCuentasData?.showModalProcedimientosPermitidos}
        onClose={onCloseModalProcedimientosPermitidos}
      >
        <ProcedimientosPermitidosTabla />
      </CustomModal>

      <CheckRender allowed={showModalLoader()}>
        <ModalLoader />
      </CheckRender>

      <CheckRender allowed={formCierreCuentasData?.showAlert}>
        <CustomAlert {...formCierreCuentasData?.alertConfig} />
      </CheckRender>
    </CustomLayout>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  formCierreCuentasData: state.ingreso.formCierreCuentasData,
  formCierreCuentasLoading: state.ingreso.formCierreCuentasLoading,

  consultarIngresoLoading: state.ingreso.consultarIngresoLoading,
  getProcedimientosPermitidosCierreCuentasLoading:
    state.ingreso.getProcedimientosPermitidosCierreCuentasLoading,
  validarProcedimientoCierreCuentasLoading:
    state.ingreso.validarProcedimientoCierreCuentasLoading,
  eliminarProcedimientoCierreCuentasLoading:
    state.ingreso.eliminarProcedimientoCierreCuentasLoading,
  cerrarCuentaClinicaLoading: state.ingreso.cerrarCuentaClinicaLoading,
});

const mapDispatchToProps = {
  formCierreCuentas: IngresoActions.formCierreCuentas,
  cerrarCuentaClinica: IngresoActions.cerrarCuentaClinica,
  validarProcedimientoCierreCuentas:
    IngresoActions.validarProcedimientoCierreCuentas,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(CierreCuentasScreen);
